/**
 * Lottie logo animation
 * Triggers when the header transitions from transparent to stuck (normal) on scroll.
 * After animation: shows [data-post-anim-logo] if set, otherwise restores the original logo.
 */
(function () {
  var STUCK_CLASS = 'js__header__stuck';

  function initLottieLogoAnimation() {
    var headerWrapper = document.querySelector('[data-header-wrapper]');
    var lottieEls = document.querySelectorAll('[data-lottie-logo]');

    if (!headerWrapper || !lottieEls.length) return;
    if (!headerWrapper.hasAttribute('data-header-transparent')) return;

    var animations = [];
    var hasPlayed = false;

    function loadAnimations() {
      if (typeof lottie === 'undefined') return;
      lottieEls.forEach(function (el) {
        var src = el.getAttribute('data-lottie-src');
        if (!src) return;
        var anim = lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: src,
        });
        animations.push({ el: el, anim: anim });
      });
    }

    function onStuck() {
      if (hasPlayed) return;
      if (!animations.length) return;
      hasPlayed = true;

      animations.forEach(function (item) {
        var logoLink = item.el.closest ? item.el.closest('.header__logo__link') : item.el.parentElement;
        var colorImg = logoLink ? logoLink.querySelector('.logo__img--color') : null;
        var textLogo = logoLink ? logoLink.querySelector('.header__logo__text') : null;
        var postAnimLogo = logoLink ? logoLink.querySelector('[data-post-anim-logo]') : null;

        // Hide the current logo
        if (colorImg) colorImg.style.opacity = '0';
        if (textLogo) textLogo.style.opacity = '0';

        // Show lottie and play
        item.el.style.display = 'block';
        item.anim.goToAndPlay(0, true);

        item.anim.addEventListener('complete', function onComplete() {
          item.anim.removeEventListener('complete', onComplete);
          item.el.style.display = 'none';

          if (postAnimLogo) {
            // Show the custom post-animation logo
            postAnimLogo.style.display = 'block';
          } else {
            // No custom logo set — restore the original
            if (colorImg) colorImg.style.opacity = '';
            if (textLogo) textLogo.style.opacity = '';
          }
        });
      });
    }

    function onUnstuck() {
      hasPlayed = false;
      animations.forEach(function (item) {
        item.el.style.display = 'none';
        item.anim.stop();

        var logoLink = item.el.closest ? item.el.closest('.header__logo__link') : item.el.parentElement;
        var colorImg = logoLink ? logoLink.querySelector('.logo__img--color') : null;
        var textLogo = logoLink ? logoLink.querySelector('.header__logo__text') : null;
        var postAnimLogo = logoLink ? logoLink.querySelector('[data-post-anim-logo]') : null;

        if (postAnimLogo) postAnimLogo.style.display = 'none';
        if (colorImg) colorImg.style.opacity = '';
        if (textLogo) textLogo.style.opacity = '';
      });
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class') {
          var isStuck = headerWrapper.classList.contains(STUCK_CLASS);
          if (isStuck && !hasPlayed) {
            onStuck();
          } else if (!isStuck) {
            onUnstuck();
          }
        }
      }
    });

    observer.observe(headerWrapper, { attributes: true, attributeFilter: ['class'] });

    if (headerWrapper.classList.contains(STUCK_CLASS)) {
      hasPlayed = true;
    }

    var attempts = 0;
    function tryLoad() {
      if (typeof lottie !== 'undefined') {
        loadAnimations();
      } else if (attempts < 30) {
        attempts++;
        setTimeout(tryLoad, 100);
      }
    }
    tryLoad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLottieLogoAnimation);
  } else {
    initLottieLogoAnimation();
  }
})();

/**
 * Header drawer: below desktop drawer breakpoint, force the hamburger to open
 * the header drawer so it uses the same configured shop-all drawer menu.
 */
(function () {
  function initMobileShopAllDrawer() {
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest && event.target.closest('[data-drawer-toggle="hamburger"]');
        if (!button || window.innerWidth >= 1020) return;

        var headerDrawer = document.querySelector('header-component > [data-drawer="hamburger"]');
        if (!headerDrawer) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        headerDrawer.dispatchEvent(
          new CustomEvent('theme:drawer:toggle', {
            bubbles: false,
            detail: {
              button: button,
            },
          })
        );
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileShopAllDrawer);
  } else {
    initMobileShopAllDrawer();
  }
})();

/**
 * Header shop-all drawer: show nested menu links in the media column when a
 * drawer menu item has children.
 */
(function () {
  function initShopAllSubmenus() {
    var menus = document.querySelectorAll('[data-shop-all-mega]');
    if (!menus.length) return;

    menus.forEach(function (menu) {
      if (menu.dataset.shopAllSubmenusInitialized === 'true') return;

      var triggers = menu.querySelectorAll('[data-shop-all-submenu-trigger]');
      var panels = menu.querySelectorAll('[data-shop-all-submenu-panel]');
      if (!triggers.length || !panels.length) return;
      menu.dataset.shopAllSubmenusInitialized = 'true';

      function setActive(id) {
        menu.classList.add('is-showing-submenu');

        triggers.forEach(function (trigger) {
          trigger.classList.toggle('is-active', trigger.getAttribute('data-shop-all-submenu-trigger') === id);
        });

        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-shop-all-submenu-panel') === id);
        });
      }

      function clearActive() {
        menu.classList.remove('is-showing-submenu');

        triggers.forEach(function (trigger) {
          trigger.classList.remove('is-active');
        });

        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });
      }

      triggers.forEach(function (trigger) {
        var id = trigger.getAttribute('data-shop-all-submenu-trigger');

        trigger.addEventListener('mouseenter', function () {
          setActive(id);
        });

        trigger.addEventListener('focusin', function () {
          setActive(id);
        });
      });

      menu.querySelectorAll('.shop-all-mega__list > li:not([data-shop-all-submenu-trigger])').forEach(function (item) {
        item.addEventListener('mouseenter', clearActive);
        item.addEventListener('focusin', clearActive);
      });

      menu.addEventListener('mouseleave', clearActive);
      menu.addEventListener('focusout', function () {
        window.requestAnimationFrame(function () {
          if (!menu.contains(document.activeElement)) {
            clearActive();
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopAllSubmenus);
  } else {
    initShopAllSubmenus();
  }

  document.addEventListener('shopify:section:load', initShopAllSubmenus);
})();

/**
 * Header drawer: on mobile, nested shop-all items expand inline instead of
 * using the desktop media-column hover panel.
 */
(function () {
  function initMobileShopAllDropdowns() {
    var drawer = document.querySelector('.drawer--header');
    if (!drawer || drawer.dataset.shopAllMobileDropdownsInitialized === 'true') return;

    var items = drawer.querySelectorAll('[data-shop-all-submenu-trigger]');
    if (!items.length) return;

    drawer.dataset.shopAllMobileDropdownsInitialized = 'true';

    items.forEach(function (item) {
      var link = Array.prototype.find.call(item.children, function (child) {
        return child.classList && child.classList.contains('shop-all-mega__link');
      });
      if (!link) return;

      link.setAttribute('aria-expanded', 'false');

      link.addEventListener('click', function (event) {
        if (window.innerWidth >= 1020) return;

        event.preventDefault();

        var isOpen = item.classList.toggle('is-mobile-open');
        link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileShopAllDropdowns);
  } else {
    initMobileShopAllDropdowns();
  }

  document.addEventListener('shopify:section:load', initMobileShopAllDropdowns);
})();

/**
 * Header: drop transparency whenever any nav dropdown is open.
 * Theme only sets `meganav--visible` for grandparent dropdowns; this mirrors it
 * for any open `hover-disclosure` so single-level menus (e.g. Shop All) also
 * make the header solid on hover.
 */
(function () {
  function initMeganavOnAnyDropdown() {
    var wrapper = document.querySelector('[data-header-wrapper]');
    if (!wrapper) return;

    var hovers = wrapper.querySelectorAll('hover-disclosure');
    if (!hovers.length) return;

    function sync() {
      if (wrapper.querySelector('hover-disclosure.is-visible')) {
        wrapper.classList.add('meganav--visible');
      } else {
        wrapper.classList.remove('meganav--visible');
      }
    }

    var observer = new MutationObserver(sync);
    hovers.forEach(function (el) {
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMeganavOnAnyDropdown);
  } else {
    initMeganavOnAnyDropdown();
  }
})();
